// extracted by mini-css-extract-plugin
module.exports = {"TagList":"tagList-module--TagList--2O_Ki","tag":"tagList-module--tag--2sim8"};